import loginLayout from '@/views/login/login.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: process.APP.TITLE,
    },
    component: loginLayout,
  },
]

export default routes
